export const ROUTES = {
  /** Clerk `<SignIn path="…" />` base; use `/login/*` route so sub-steps do not remount. */
  LOGIN: '/login',
  SIGNUP: '/signup',
  /** Old custom-auth paths — AppRouter redirects these to LOGIN */
  SET_PASSWORD: '/set-password',
  FORGOT_PASSWORD: '/forgotpassword',
  RESET_PASSWORD: '/resetpassword',
  CONFIRM_EMAIL: '/confirmemail',
  DOC_GENERATION: '/doc-generation',
  RAG_SYSTEM: '/rag-system',
  DASHBOARD: '/dashboard',
  BRD: '/brd',
};
